import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const PricingTextBlock = (): JSX.Element => (
  <Grid padding={['spacing-none', 'spacing-4xl']}>
    <Stack
      maxWidth='width-xl'
      margin={['spacing-none', 'spacing-auto']}
    >
      <HeadingAndSupportingText
        gap='spacing-3xl'
        subHeadingGap='spacing-lg'
        subHeading={{
          text: 'Pricing',
          type: 'paragraph',
          size: 'lg',
          textAlign: 'center',
          color: 'text-brand-secondary',
          fontWeight: 'font-weight-semibold',
        }}
        heading={{
          text: 'No surprise add-ons',
          type: 'heading',
          size: 'xl',
          letterSpacing: -1.4,
          textAlign: 'center',
        }}
        supportingText={{
          text: 'We add more features, white-labeling, and support as you grow. We don’t add extra fees for more spaces, admins, and other essentials.',
          type: 'paragraph',
          size: 'xl',
          textAlign: 'center',
          color: 'text-tertiary',
        }}
      />
    </Stack>
  </Grid>
);

export default PricingTextBlock;
